import { render, staticRenderFns } from "./SalonInfo.vue?vue&type=template&id=200f0774"
import script from "./SalonInfo.vue?vue&type=script&lang=js"
export * from "./SalonInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports